import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function WhyFailedSection() {
  const failures = ['Los tutoriales de YouTube son piezas de un rompecabezas que nunca encajan del todo.', "Los cursos de 'expertos' están llenos de teoría pesada que no aplica a quien empieza con poco presupuesto.", 'Intentar configurar Shopify sin una ruta crítica te hace perder horas en botones y funciones que no necesitas para vender.', "El miedo a no verse 'profesional' te detiene de lanzar, cuando la realidad es que lo 'hecho' vende más que lo 'perfecto'."];
  return <section className="py-20 bg-white px-4" data-id="element-220">
      <div className="max-w-4xl mx-auto" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-222">
          <h2 className="text-4xl md:text-5xl font-bold text-navy-900 mb-4" data-id="element-223">
            Por Qué Lo Que Has Intentado{' '}
            <span className="text-red-600" data-id="element-224">No Ha Funcionado</span>
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-225">
          {failures.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="flex items-start gap-4 p-6 bg-gray-50 rounded-lg border border-gray-100 hover:shadow-md transition-shadow" data-id="element-226">
              <XCircleIcon className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-227" />
              <p className="text-lg text-gray-700 font-medium" data-id="element-228">{item}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}